module.exports = __webpack_public_path__ + "img/21-the-case-for-social-cities.8a2a9778.jpg";